import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Condition} from "../../model/condition";

@Component({
  selector: 'gen-condition-viewer',
  templateUrl: './condition-viewer.component.html',
  styleUrls: ['./condition-viewer.component.scss', '../../trial-curation-styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConditionViewerComponent {

  @Input() condition: Condition;
  @Input() first: boolean;
  @Input() last: boolean;
  @Input() type: string;

  constructor() {
  }

  ngOnInit() {
  }

  public get operator() {
    switch (this.type) {
      case "any":
        return "OR";
      case "all":
        return "AND";
      case "none":
        return "OR";
      default:
        return "ERROR";
    }
  }
}
